"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, switchMap, catchError, map } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvParticipantsConstants } from "../_constants/lcvParticipants.constants";
import {
     lcvParticipantsGetJobRolesComplete,
     lcvParticipantsImportComplete,
     lcvParticipantsGetImportHistoryComplete,
} from "../_actions/lcvParticipants.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";

// Reads use switchMap so a newer request wins; the write uses mergeMap so it is never cancelled.
const post = (url, action, complete, operator) =>
     operator((incoming) =>
          ajax
               .post(url, incoming.payload, getRequestHeader(requestTypes.REQUEST_TYPE_POST))
               .pipe(
                    map((ajaxResponse) => complete(ajaxResponse.response)),
                    catchError((error) => of(ajaxError(error))),
               ),
     );

export const lcvParticipantsGetJobRolesEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvParticipantsConstants.LCV_PARTICIPANTS_GET_JOB_ROLES_REQUEST),
          post("/api/lcvParticipants/getJobRoles", null, lcvParticipantsGetJobRolesComplete, switchMap),
     );
};

export const lcvParticipantsImportEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvParticipantsConstants.LCV_PARTICIPANTS_IMPORT_REQUEST),
          post("/api/lcvParticipants/importParticipants", null, lcvParticipantsImportComplete, mergeMap),
     );
};

export const lcvParticipantsGetImportHistoryEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvParticipantsConstants.LCV_PARTICIPANTS_GET_IMPORT_HISTORY_REQUEST),
          post("/api/lcvParticipants/getImportHistory", null, lcvParticipantsGetImportHistoryComplete, switchMap),
     );
};
